import { Controller } from '@hotwired/stimulus';
import { FriendlyCaptchaSDK } from '@friendlycaptcha/sdk';

export default class extends Controller {
  static targets = ['captcha'];

  static values = {
    apiEndpoint: String,
    sitekey: String,
    solutionFieldName: String,
  };

  connect() {
    this.#createCaptcha();
  }

  #createCaptcha() {
    const sdk = new FriendlyCaptchaSDK({
      apiEndpoint: this.apiEndpointValue,
    });

    const widgetInstance = sdk.createWidget({
      element: this.captchaTarget,
      formFieldName: this.solutionFieldNameValue,
      sitekey: this.sitekeyValue,
    });

    widgetInstance.addEventListener('frc:widget.complete', this.#captchaComplete.bind(this));
    widgetInstance.addEventListener('frc:widget.expired', this.#captchaExpired.bind(this));
  }

  #captchaComplete() {
    this.dispatch('complete');
  }

  #captchaExpired() {
    this.dispatch('expired');
  }
}
